var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "menu-body-wrapper" }, [
    _c(
      "div",
      {
        staticClass: "menu-item-wrapper",
        class: { landscape: _vm.isMobileLandscape },
      },
      [
        _c(
          "div",
          {
            staticClass: "menu-item",
            on: {
              click: function ($event) {
                $event.stopPropagation()
                return _vm.openMenuPopup("History")
              },
            },
          },
          [
            _c("img", {
              attrs: {
                src: require("@/assets/images/history-icon.webp"),
                alt: "",
              },
            }),
            _c("span", { staticClass: "label" }, [
              _vm._v(_vm._s(_vm.$t("History"))),
            ]),
          ]
        ),
        _vm.withCommission
          ? _c(
              "div",
              {
                staticClass: "menu-item",
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    return _vm.openMenuPopup("Statement")
                  },
                },
              },
              [
                _c("img", {
                  attrs: {
                    src: require("@/assets/images/statement-icon.webp"),
                    alt: "",
                  },
                }),
                _c("span", { staticClass: "label" }, [
                  _vm._v(_vm._s(_vm.$t("Statement"))),
                ]),
              ]
            )
          : _vm._e(),
        _c(
          "div",
          {
            staticClass: "menu-item",
            on: {
              click: function ($event) {
                $event.stopPropagation()
                return _vm.openMenuPopup("Help")
              },
            },
          },
          [
            _c("img", {
              attrs: {
                src: require("@/assets/images/help-icon.webp"),
                alt: "",
              },
            }),
            _c("span", { staticClass: "label" }, [
              _vm._v(_vm._s(_vm.$t("Help"))),
            ]),
          ]
        ),
        _vm.config.enableJackpot
          ? _c(
              "div",
              {
                staticClass: "menu-item",
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    return _vm.openMenuPopup(_vm.PopupPage.jackpotHelp)
                  },
                },
              },
              [
                _c("img", {
                  attrs: {
                    src: require("@/assets/images/jackpot-help-icon.webp"),
                    alt: "",
                  },
                }),
                _c("span", { staticClass: "label" }, [
                  _vm._v(_vm._s(_vm.$t("Jackpot"))),
                ]),
              ]
            )
          : _vm._e(),
        _c(
          "div",
          {
            staticClass: "menu-item",
            on: {
              click: function ($event) {
                $event.stopPropagation()
                return _vm.openMenuPopup("Notification")
              },
            },
          },
          [
            _c("img", {
              attrs: {
                src: require("@/assets/images/notification-icon.webp"),
                alt: "",
              },
            }),
            _c("span", { staticClass: "label" }, [
              _vm._v(_vm._s(_vm.$t("Notification"))),
            ]),
          ]
        ),
      ]
    ),
    _c("div", { staticClass: "game-actions" }, [
      _c("div", { staticClass: "game-actions__toggles" }, [
        _c(
          "div",
          { staticClass: "odds-toggle" },
          [
            _vm.config.availableOddsType.length > 1
              ? _c("ToggleBtn", {
                  staticClass: "credit-user-menu-item",
                  attrs: {
                    leftTxt: _vm.$t("Eu"),
                    rightTxt: _vm.$t("My"),
                    value: _vm.toggleValue,
                  },
                  on: { toggle: (e) => _vm.toggleOdds(e) },
                })
              : _vm._e(),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "floating-video-toggle" },
          [
            _c("ToggleBtn", {
              attrs: {
                rightTxt: _vm.$t("float video"),
                value: _vm.isFloatingVideo,
              },
              on: { toggle: (e) => _vm.handleChangeToogleValue(e) },
            }),
          ],
          1
        ),
      ]),
      _vm.withCommission
        ? _c(
            "div",
            {
              staticClass: "logout-user",
              on: {
                click: function ($event) {
                  return _vm.logoutCreditUser()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("Logout")))]
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }